export enum ERROR_MESSAGES {
  MANDATORY_PARAMS_MISS = 'Mandatory parameters missed',
}
